import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "../../../../environments/environment";
import { Week } from "../../../domain/models/agreement.model";
import {
  DeleteAbsenceResponse,
  MappedRetrieveWeeksListAbsenceResponse,
  MappedWeeksForListAbsenceResponse,
  RetrievePlanningResponse,
  RetrieveWeeksListAbsenceResponse,
} from "../../../domain/models/personnel.model";
import { PersonnelRepository } from "../../../domain/repositories/personnel.repository";

@Injectable()
export class PersonnelRepositoryImpl extends PersonnelRepository {
  private endpoint = environment.apiUrl;
  constructor(private http: HttpClient) {
    super();
  }
  override retrieveResourcePlanning(
    resourceId: number,
  ): Observable<RetrievePlanningResponse> {
    return this.http
      .get<RetrievePlanningResponse>(
        `${this.endpoint}/hr/resource/${resourceId}/planning`,
      )
      .pipe(map((response) => response));
  }

  override retrieveWeeksListAbsence(): Observable<MappedRetrieveWeeksListAbsenceResponse> {
    return this.http
      .get<RetrieveWeeksListAbsenceResponse>(
        `${this.endpoint}/hr/weeks-from-now`,
      )
      .pipe(
        map((response: RetrieveWeeksListAbsenceResponse) => {
          let res = response.weeks.map(
            (w: Week) =>
              ({
                ...w,
                description: `From: ${w.dateStart} to: ${w.dateEnd}`,
              }) as MappedWeeksForListAbsenceResponse,
          );
          return { weeks: res.slice(0, 100) };
        }),
      );
  }

  override deleteAbsence(absenceId: number): Observable<DeleteAbsenceResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http
      .delete(
        `${this.endpoint}/hr/remove-weekly-absence/${absenceId}`,
        httpOptions,
      )
      .pipe(
        map((response: any) => {
          return response;
        }),
      );
  }

  override retrieveWeeklyAbsence(resourceId: number): Observable<any[]> {
    return this.http
      .get(`${this.endpoint}/hr/resource/${resourceId}/absence`)
      .pipe(
        map((response: any) => {
          let res = response.absence;
          return res;
        }),
      );
  }
}
